import React from 'react';
import { connect } from 'react-redux';
import '../App.css';

class Subheader extends React.Component {
    render() {
        const { channel, isPrivateChannel, channelCreatedBy, channelCreatedByAvatar, channelDetails } = this.props;

        if (isPrivateChannel || !channel) return null;

        return (
            
            <div style={{display: 'grid'}}>
            {!isPrivateChannel && (<div 
                className="channelHeaderDetails" 
                style={{
                    fontFamily: 'proxima-nova, sans-serif',
                    fontWeight: 500,
                    fontStyle: 'normal',
                    display: 'flex'
                }}>
                <h3>Details:</h3>
                &nbsp;&nbsp;{channel && channelDetails}
            </div>)}

            {!isPrivateChannel && (<div 
                className="channelHeaderDetails createdByHeaderDetails" 
                style={{
                    fontFamily: 'proxima-nova, sans-serif',
                    fontWeight: 500,
                    fontStyle: 'normal',
                    display: 'flex',
                }}>
                <h3>Created by:</h3>
                &nbsp;&nbsp;
                <img src={channel && channelCreatedByAvatar} alt="Avatar" className="messagesHeaderUserAvatar" />
                &nbsp;&nbsp;{channel && channelCreatedBy}
            </div>)}
        </div>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.currrentUser,
    currentChannel: state.channel.currentChannel,
    isPrivateChannel: state.channel.isPrivateChannel
  });
  
  export default connect(mapStateToProps)(Subheader);


// WEBPACK FOOTER //
// ./src/components/Messages/Subheader.js